import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { NumberToCurrencyPipe } from "../../../../shared/pipes/number-to-currency.pipe";
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { IShowPriceCategoryPackage } from '../../../shows/core/interfaces/IShowPriceCategory';

@Component({
  selector: 'app-package-selection',
  standalone: true,
  imports: [
    TranslatePipe,
    NumberToCurrencyPipe
],
  templateUrl: './package-selection.component.html',
  styleUrl: './package-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageSelectionComponent extends BaseComponent {

  @Input({ required: true }) packages: IShowPriceCategoryPackage[];
  @Output() packageSelected = new EventEmitter<IShowPriceCategoryPackage>();

  public selectedPackage: IShowPriceCategoryPackage | null = null;

  public selectPackage(pkg: IShowPriceCategoryPackage): void {
    if (this.selectedPackage?.id === pkg.id && this.selectedPackage?.priceAreaId === pkg.priceAreaId) {
      this.selectedPackage = null;
    } else {
      this.selectedPackage = pkg;
    }

    this.cdr.detectChanges();
    this.packageSelected.emit(this.selectedPackage);
  }
}